module.exports = __webpack_public_path__ + "img/icon-clipboard-active.d42de381.svg";